/**
 * @generated SignedSource<<be56b5a63c7de601907f7dc99965fc1e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyRespRefineMenu_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilters_viewer">;
  readonly " $fragmentType": "BuyRespRefineMenu_viewer";
};
export type BuyRespRefineMenu_viewer$key = {
  readonly " $data"?: BuyRespRefineMenu_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyRespRefineMenu_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyRespRefineMenu_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8977a5836480d7532ae50368c5bd10b0";

export default node;
